import '../App.css'
import { deleteTodo, updateTodo, deleteActiveTodo, deleteFinishedTodo } from '../store/action'
import { useDispatch } from 'react-redux'
import { Circle, CheckCircle, XCircle } from 'react-feather'

export default function Todo (props) {
  const dispatch = useDispatch()

  function destroyTodo () {
    if (props.todo.status === '') {
      dispatch(deleteTodo(props.todo))
    } else if (props.todo.status === 'unfinished') {
      dispatch(deleteActiveTodo(props.todo))
    } else if (props.todo.status === 'finished') {
      dispatch(deleteFinishedTodo(props.todo))
    }
  }

  function editStatus () {
    dispatch(updateTodo({
      index: props.index,
      id: props.todo.id,
      title: props.todo.title,
      status: 'finished',
      info: props.status
    }))
  }

  function editStatusToUnfinished () {
    dispatch(updateTodo({
      index: props.index,
      id: props.todo.id,
      title: props.todo.title,
      status: 'unfinished',
      info: props.status
    }))
  }
  
  return (
    <>
      <div className="card">
        <div className="card-body custom-card-parent">
          <div className="custom-card">
            {
              props.todo.status === 'unfinished' ? 
              <div className="card-detail Invisible-btn" onClick={editStatus}><Circle/></div> :
              <div className="card-detail Invisible-btn" onClick={editStatusToUnfinished}><CheckCircle/></div>
            }
            <div className="card-detail">
              {
                props.todo.title
              }
            </div>
          </div>
          <div>
          <div className="card-detail Invisible-btn" onClick={destroyTodo}><XCircle stroke="red"/></div>
          </div>
        </div>
      </div>
    </>
  )
}